import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LabelingColorService } from '@features/labeling/services/labeling-color.service';
import { LabelingShortcutService } from '@features/labeling/services/labeling-shortcut.service';
import { LabelingService } from '@features/labeling/services/labeling.service';
import { AnnotationFactory } from '../services/annotation.factory';
import { LabelingAnswerService } from '../services/labeling-answer.service';

@Component({
    selector: 'labeling-container',
    templateUrl: './labeling-container.component.html',
    styleUrls: ['./labeling-container.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        LabelingService,
        LabelingColorService,
        LabelingShortcutService,
        AnnotationFactory,
        LabelingAnswerService,
    ]
})
export class LabelingContainerComponent {

    constructor() { }

}
